import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import MaterialTableComponent from "../../NestedComponents/widgets/materialTable";
import { Button } from "@material-ui/core";
import docService from "../../Services/docsService";
import Checkbox from "@material-ui/core/Checkbox";
import adminService from "../../Services/adminService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import OptionsGenerator from "../../NestedComponents/widgets/optionsGenerator";
import AttachOrRemoveFieldDoc from "../../NestedComponents/widgets/attachOrRemoveFieldDoc";

import Swal from "sweetalert2";

class AdminFieldsManager extends Component {
  state = {
    allFields: null,
    allFieldsCopy: null,
    tableView: ["all"],
    tableViewCheckbox: ["all"],
    isGenerateOptionsOpen: false,
    isAttachFieldToDocOpen: false,
    focusedDoc: null
  };

  componentDidMount() {
    docService.getAllFields().then((res) => {
      if (res["success"]) {
        var allFields = res["fieldsFromDB"];
        allFields = allFields.map((item) => {
          if (!item.options) return item;
          item.options = item.options.join(";");
          return item;
        });
        this.setState({ allFields, allFieldsCopy: allFields });
      }
    });

    docService.getDocsInfoAndFields(true).then((res) => {
      if (res["success"]) {
        var docsList = res["docsList"];
        this.setState({ docsList });
      }
    });
  }

  render() {
    return (
      <div>
        <h3 className="yellow-color">רשימת שדות שקיימים במערכת</h3>
        <div>
          {this.state.docsList && this.state.docsList[0] ? (
            <div>
              <div className="inline-block">
                <Autocomplete
                  className="custom-autocomplete"
                  options={this.state.docsList}
                  // options={this.state.docsList.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                  // groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.aliasName}
                  style={{ width: 300 }}
                  renderInput={(params) => <TextField {...params} label="מסמכים שקיימים במערכת" variant="outlined" />}
                  onInputChange={(event, newInputValue) => {
                    this.showSpecificFields(newInputValue);
                  }}
                />
              </div>
              <div className="inline-block mr-20">
                <Button
                  className="mr-20 mt-20"
                  onClick={this.generateOptions}
                  color="secondary"
                  variant="contained"
                  size="small"
                >
                  <i className="material-icons width40">settings</i>
                </Button>
              </div>
              {this.state.focusedDoc ? (
                <div className="inline-block mr-20">
                  <Button
                    className="mr-20 mt-20"
                    onClick={this.attachOrRemoveFieldToDoc}
                    color="primary"
                    variant="contained"
                    size="small"
                  >
                    <i className="material-icons width40">text_fields</i>
                  </Button>
                </div>
              ) : null}
            </div>
          ) : null}

          <div className="full-line-bordered questionnaire-field-wrapper">
            <span className="primary-color">בחר סוג צפייה בטבלה:</span>
            <FormControlLabel
              className="align-checkbox-opts"
              control={<Checkbox value="options" color="primary" />}
              label="אופציות"
              checked={this.state.tableViewCheckbox.includes("options")}
              onChange={this.handleTableViewChange}
            />
            <FormControlLabel
              className="align-checkbox-opts"
              control={<Checkbox value="depended" color="primary" />}
              label="תלוי"
              checked={this.state.tableViewCheckbox.includes("depended")}
              onChange={this.handleTableViewChange}
            />
            <FormControlLabel
              className="align-checkbox-opts"
              control={<Checkbox value="fieldConnector" color="primary" />}
              label="חיבור שדה"
              checked={this.state.tableViewCheckbox.includes("fieldConnector")}
              onChange={this.handleTableViewChange}
            />
            <FormControlLabel
              className="align-checkbox-opts"
              control={<Checkbox value="info" color="primary" />}
              label="מידע נוסף"
              checked={this.state.tableViewCheckbox.includes("info")}
              onChange={this.handleTableViewChange}
            />
          </div>
        </div>

        {this.state.allFields && this.state.allFields[0] && this.state.tableView[0] ? (
          <MaterialTableComponent
            data={this.state.allFields}
            columns={this.getSelectedCols(this.state.tableView)}
            tableTitle="ניהול שדות"
            onDataChanged={this.handleTableDataChange}
            options={{ pageSize: 20 }}
          />
        ) : (
          <div>Loading...</div>
        )}
        <OptionsGenerator isOpen={this.state.isGenerateOptionsOpen} closePopup={this.closePopupGenerateOpts} />
        <AttachOrRemoveFieldDoc
          isOpen={this.state.isAttachFieldToDocOpen}
          closePopup={this.closePopupAttachFieldToDoc}
          addOrRemoveKeyFromDoc={this.addOrRemoveKeyFromDoc}
        />
      </div>
    );
  }

  generateOptions = () => {
    this.setState({ isGenerateOptionsOpen: true });
  };

  closePopupGenerateOpts = () => {
    this.setState({ isGenerateOptionsOpen: false });
  };

  attachOrRemoveFieldToDoc = () => {
    this.setState({ isAttachFieldToDocOpen: true });
  };

  closePopupAttachFieldToDoc = () => {
    this.setState({ isAttachFieldToDocOpen: false });
  };

  addOrRemoveKeyFromDoc = (key, action) => {
    // action -> 'add' or 'remove'
    if (!key || !action) return;
    var allowedToAdd = false;
    for (const field of this.state.allFieldsCopy) {
      if (field.key === key) {
        allowedToAdd = true;
        break;
      }
    }
    if (!allowedToAdd) {
      Swal.fire("You must add the field first to the list of 'All Fields' ", "", "warning");
      return;
    }
    adminService.adminAddOrRemoveKeyFromDoc(key, this.state.focusedDoc.nameWithExtension, action).then((res) => {
      if (res["success"]) {
        Swal.fire(`${action} - בוצע`, "", "success");
      } else {
        Swal.fire("Something went wrong", "", "warning");
      }
    });
  };

  handleTableDataChange = (dataToModify, action) => {
    return new Promise((resolve, reject) => {
      if (action === "UPDATE") {
        if (dataToModify.options) {
          // validate options
          Swal.fire({
            title: "אתה משנה שדה שיש לו אופציות נוספות. יש לוודא נכונות הפרטים",
            html: dataToModify.options.toString().replace(/;/g, "<br/>"),
            icon: "warning",
            showCancelButton: true
          }).then((result) => {
            if (result.value) {
              adminService.adminUpdateFieldData({ dataToModify }).then((res) => {
                if (res["success"]) {
                  resolve();
                  Swal.fire(`${action} - בוצע`, "", "success");
                } else {
                  reject();
                }
              });
            } else {
              reject();
            }
          });
        } else {
          adminService.adminUpdateFieldData({ dataToModify }).then((res) => {
            if (res["success"]) {
              resolve();
              Swal.fire(`${action} - בוצע`, "", "success");
            } else {
              reject();
            }
          });
        }
      } else if (action === "NEW") {
        for (const field of this.state.allFieldsCopy) {
          if (field.key === dataToModify.key) {
            Swal.fire("Field already exist", "", "warning");
            return reject();
          }
        }
        adminService.adminNewFieldData(dataToModify.key).then((res) => {
          if (res["success"]) {
            var allFieldsCopy = [...this.state.allFieldsCopy];
            allFieldsCopy.push({ key: dataToModify.key, _id: res["_id"] });
            this.setState({ allFieldsCopy, allFields: [] });
            setTimeout(() => {
              this.setState({ allFields: allFieldsCopy });
              resolve();
            }, 200);
            Swal.fire(`${action} - בוצע`, "", "success");
          } else {
            Swal.fire("something went wrong", "", "warning");
            reject();
          }
        });
      } else {
        return reject();
      }
    });
  };

  showSpecificFields = (docName) => {
    if (!docName) {
      this.setState({ allFields: [] });
      setTimeout(() => {
        this.setState({ allFields: this.state.allFieldsCopy, focusedDoc: null });
      }, 200);
      return;
    }
    for (const doc of this.state.docsList) {
      if (doc.aliasName === docName) {
        var newFieldsToDisplay = this.state.allFieldsCopy.filter((field) => doc.tags.includes(field.key));
        this.setState({ allFields: [] });
        setTimeout(() => {
          this.setState({ allFields: newFieldsToDisplay, focusedDoc: doc });
        }, 200);
        return;
      }
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleTableViewChange = (e) => {
    var copyTableView = [...this.state.tableView];
    if (e.target.checked) {
      copyTableView.push(e.target.value);
    } else {
      copyTableView = copyTableView.filter((item) => item !== e.target.value);
    }

    this.setState({ tableView: [], tableViewCheckbox: copyTableView });

    setTimeout(() => {
      this.setState({ tableView: copyTableView });
    }, 200);
  };

  getSelectedCols = function (tableView) {
    // If not any checkbox is seleted -> show all cols
    if (tableView[0] == "all" && tableView.length === 1) {
      return [
        { title: "קוד שדה", field: "key", editable: "onAdd" },
        { title: "משקל שדה", field: "fieldWeight", type: "numeric" },
        { title: "כותרת שדה לעורך הדין", field: "lawyerLabel" },
        { title: "כותרת שדה ללקוח", field: "clientLabel" },
        {
          title: "שייך לטאב",
          field: "belongToTab",
          lookup: {
            SELLERS_INFO: "פרטי המוכרים",
            BUYERS_INFO: "פרטי הקונים",
            THITD_PARTY: "צד שלישי",
            ASSET_INFO: "פרטי ממכר",
            LAWYER_INFO: "פרטי המייצגים",
            GENERAL: "כללי"
          }
        },
        {
          title: "סוג שדה",
          field: "type",
          lookup: {
            nothing: "unset",
            txt: "txt",
            date: "date",
            number: "number",
            numberWithCommas: "numberWithCommas",
            selectRange: "selectRange",
            selectOptions: "selectOptions",
            textarea: "textarea",
            checkbox: "checkbox",
            radio: "radio",
            longList: "longList",
            radioValues: "radioValues"
          }
        },
        { title: "אופציות", field: "options" },
        { title: "כותרת אופציות", field: "optionsTitle" },
        { title: "קוד אופציות", field: "optionsKey" },
        // { title: "חיבור שדות", field: "isFieldConnector", lookup: { 0: "no", 1: "yes" } },
        { title: "מספר התחלה", field: "startRange" },
        { title: "מספר סוף", field: "endRange" },
        {
          title: "האם שדה תלוי?",
          field: "isDepended",
          lookup: {
            yes: "yes",
            no: "no"
          }
        },
        { title: "הקוד שהשדה תלוי בו", field: "dependedOn" },
        { title: "הקוד שהשדה תלוי בו שלא יהיה", field: "isDependedNot" },
        { title: "ערך ספציפי שהשדה תלוי בו", field: "dependedOnSpecificVal" },
        // { title: "תת קוד תלוי", field: "subCodeDepended" },
        { title: "קוד למידע נוסף", field: "infoKey" },
        { title: "מידע נוסף", field: "info" },
        { title: "שם קובץ מידע", field: "longListName" }
      ];
    }
    var colsToShow = [
      { title: "קוד שדה", field: "key", editable: "onAdd" },
      { title: "משקל שדה", field: "fieldWeight", type: "numeric" },
      { title: "כותרת שדה לעורך הדין", field: "lawyerLabel" },
      { title: "כותרת שדה ללקוח", field: "clientLabel" },
      {
        title: "שייך לטאב",
        field: "belongToTab",
        lookup: {
          SELLERS_INFO: "פרטי המוכרים",
          BUYERS_INFO: "פרטי הקונים",
          THITD_PARTY: "צד שלישי",
          ASSET_INFO: "פרטי ממכר",
          LAWYER_INFO: "פרטי המייצגים",
          GENERAL: "כללי"
        }
      },
      {
        title: "סוג שדה",
        field: "type",
        lookup: {
          nothing: "unset",
          txt: "txt",
          date: "date",
          number: "number",
          numberWithCommas: "numberWithCommas",
          selectRange: "selectRange",
          selectOptions: "selectOptions",
          textarea: "textarea",
          checkbox: "checkbox",
          radio: "radio",
          longList: "longList",
          radioValues: "radioValues"
        }
      }
    ];
    if (tableView.includes("options")) {
      colsToShow.push({ title: "אופציות", field: "options" });

      colsToShow.push({ title: "מספר התחלה", field: "startRange" });
      colsToShow.push({ title: "מספר סוף", field: "endRange" });
    }
    // if (tableView.includes("fieldConnector")) {
    colsToShow.push({ title: "כותרת אופציות", field: "optionsTitle" });
    colsToShow.push({ title: "קוד אופציות", field: "optionsKey" });
    // colsToShow.push({ title: "חיבור שדות", field: "isFieldConnector", lookup: { 0: "no", 1: "yes" } });
    // }

    if (tableView.includes("depended")) {
      colsToShow.push({
        title: "האם שדה תלוי?",
        field: "isDepended",
        lookup: {
          yes: "yes",
          no: "no"
        }
      });
      colsToShow.push({ title: "הקוד שהשדה תלוי בו", field: "dependedOn" });
      colsToShow.push({ title: "הקוד שהשדה תלוי בו שלא יהיה", field: "isDependedNot" });
      colsToShow.push({ title: "ערך ספציפי שהשדה תלוי בו", field: "dependedOnSpecificVal" });
      // colsToShow.push({ title: "תת קוד תלוי", field: "subCodeDepended" });
    }
    if (tableView.includes("info")) {
      colsToShow.push({ title: "קוד למידע נוסף", field: "infoKey" });
      colsToShow.push({ title: "מידע נוסף", field: "info" });
    }
    return colsToShow;
  };
}

export default AdminFieldsManager;
